var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgStarActive15X = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28px",
  height: "26px",
  viewBox: "0 0 28 26",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "6E140F0B-6F75-48B8-BEC4-28161BE67C12@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83D\\uDD27-Workspace",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-1440-/-Home-Page-/-Search-Results",
  transform: "translate(-274.000000, -172.000000)",
  fill: "#010b3b"
}, /*#__PURE__*/React.createElement("g", {
  id: "Hero-Section-/-Featured",
  transform: "translate(208.000000, 120.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Heading-/-Featured-Copy",
  transform: "translate(64.000000, 50.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.4405957,22.9748534 L8.8746146,27.4061006 C8.41682858,27.7150511 7.79526583,27.594396 7.48631535,27.13661 C7.32085961,26.8914467 7.27242078,26.5856159 7.35401891,26.3013231 L9.53938566,18.6873734 C9.65189796,18.2953737 9.51509074,17.8743244 9.19365477,17.6233231 L2.95028855,12.7480347 C2.51499552,12.4081253 2.43767183,11.7796995 2.77758126,11.3444065 C2.95961679,11.1112891 3.23551069,10.9707141 3.53110442,10.9604673 L11.4477164,10.6860347 C11.8552984,10.6719057 12.2134644,10.4116829 12.3528516,10.0284154 L15.0602202,2.58407435 C15.2489803,2.06504828 15.8227544,1.79731485 16.3417805,1.98607498 C16.6197403,2.08716383 16.838691,2.30611446 16.9397798,2.58407435 L19.6471484,10.0284154 C19.7865356,10.4116829 20.1447016,10.6719057 20.5522836,10.6860347 L28.4688956,10.9604673 C29.0208488,10.9796009 29.4527844,11.4425583 29.4336507,11.9945115 C29.4234038,12.2901053 29.2828288,12.5659992 29.0497115,12.7480347 L22.8063452,17.6233231 C22.4849093,17.8743244 22.348102,18.2953737 22.4606143,18.6873734 L24.6459811,26.3013231 C24.7983468,26.8321745 24.4915236,27.3860313 23.9606723,27.538397 C23.6763795,27.6199951 23.3705487,27.5715563 23.1253854,27.4061006 L16.5594043,22.9748534 C16.2213587,22.7467133 15.7786413,22.7467133 15.4405957,22.9748534 Z",
  id: "Star"
})))))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgStarActive15X);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/StarActive@1_5x.d89a7129c8f2089de8833bad345b999c.svg";